import { Link } from '@tanstack/react-router';

export function NaoEncontrado() {
  return (
    <main className="pagina-central">
      <h1>Página não encontrada</h1>
      <p>O endereço pode estar errado ou a página foi removida.</p>
      <Link to="/">Ir para o início</Link>
    </main>
  );
}
